import currenciesList from "./currencies-list.json";

export interface Currency {
  countryId: string;
  currencyCode: string;
}

export const currencies: readonly Currency[] = Object.freeze(currenciesList) as Currency[];
